import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgCoach(props: RootSvgProps) {
  const { ...others } = props;

  return (
    <RootSvg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <rect width="70" height="70" rx="10" fill="#E6FFF3" />
      <g clipPath="url(#clip0_3344_35621)">
        <path
          d="M35 22C26.7157 22 20 28.8133 20 37.218C20 45.6227 26.7157 52.436 35 52.436C43.2842 52.436 49.9999 45.6227 49.9999 37.218C49.9911 28.8171 43.2806 22.009 35 22ZM41.317 37.7029C41.2132 37.9142 41.0444 38.0855 40.836 38.1909V38.1963L32.2646 42.5443C31.7353 42.8127 31.0918 42.5949 30.8272 42.0579C30.752 41.9052 30.7133 41.7367 30.7142 41.566V32.87C30.714 32.2697 31.1934 31.7828 31.7852 31.7825C31.9516 31.7824 32.1158 31.8217 32.2646 31.8971L40.836 36.2452C41.3656 36.5129 41.581 37.1656 41.317 37.7029Z"
          fill="#00C968"
        />
      </g>
      <defs>
        <clipPath id="clip0_3344_35621">
          <rect
            width="30"
            height="30.4361"
            fill="white"
            transform="translate(20 22)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
